module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flagDisplayBar) ? _c('div', [_c('h6', {
    staticClass: "text-gray",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.barData.Label))]), _vm._v(" "), (_vm.buttonDisplayColor == 1) ? _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v(_vm._s(_vm.displayValue) + " " + _vm._s(_vm.barData.AfterText) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.buttonDisplayColor == 2) ? _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-warning",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v(_vm._s(_vm.displayValue) + " " + _vm._s(_vm.barData.AfterText) + " ")])])]) : _vm._e(), _vm._v(" "), (_vm.buttonDisplayColor == 3) ? _c('div', [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    style: ({
      width: _vm.actualBarWidth
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "100",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v(_vm._s(_vm.displayValue) + " " + _vm._s(_vm.barData.AfterText) + " ")])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b9d1519","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/RelativePowerBar.vue
// module id = 1568
// module chunks = 4